import React, { useEffect, useRef, useState } from "react";
import SummarySection from "./SummarySection";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AIAvtar from "../../assets/svg/AI Avatar.svg";
import SendIcon from "../../assets/svg/sendIcon.svg";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  fetchChatDetailsAPI,
  filterPropertyAPI,
} from "../../services/apiServices";
import { useAuthStore } from "../../redux/features/authSlice";
import { setToken } from "../../utils/axiosClient";
import { questions } from "./AiBasicComponent/question";
import { UserMessage } from "./AiBasicComponent/UserMessage";
import HistorySection from "./HistorySection";
import { usePropertyStore } from "../../redux/features/propertyDetailSlice";
import { useRedirectStore } from "../../redux/features/userRedirectSlice";

const AiHistoryDetail = ({ message, setHistoryData, setCountData }) => {
  const { loginInfo } = useAuthStore();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { removePropertyInfo } = usePropertyStore();
  const [chatDeatils, setChatDeatils] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const onClickChat = async (id) => {
    try {
      setToken(loginInfo ? loginInfo?.token : null);
      setLoading(true);
      const response = await fetchChatDetailsAPI({ chatHistoryId: id });
      if (response?.data?.statusCode == 200) {
        const { chatHistory } = response?.data?.data;
        setChatDeatils(chatHistory);
        setHistoryData(chatHistory);

        if (chatHistory?.length > 0) {
          setCountData(chatHistory[0]?.count);
        }
        if (chatHistory?.length >= 1) {
          setCountData(chatHistory[0]?.count);
        }
        if (chatHistory?.length >= 2) {
          setCountData(chatHistory[1]?.count);
        }
        if (chatHistory?.length >= 3) {
          setCountData(chatHistory[2]?.count);
        }
        if (chatHistory?.length >= 4) {
          setCountData(chatHistory[3]?.count);
        }
        if (chatHistory?.length >= 5) {
          setCountData(chatHistory[4]?.count);
        }
        if (chatHistory?.length >= 6) {
          setCountData(chatHistory[5]?.count);
        }
        if (chatHistory?.length >= 7) {
          setCountData(chatHistory[6]?.count);
        }
      } else {
        console.warn(
          "error fetching chat list with title in API gives 401",
          response
        );
      }
    } catch (error) {
      console.warn("error============", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      onClickChat(id);
    }
  }, [id]);

  const newChat = () => {
    removePropertyInfo();
    navigate("/");
  };
  if (!message) {
    return "";
  }
  return (
    <div className="mt-5">
      {chatDeatils?.length > 0 &&
        chatDeatils?.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <div>
                <div className="flex gap-4 max-w-[calc(100%-80px)]">
                  <img src={AIAvtar} alt="AI Avatar" className="w-10 h-10" />
                  <div>
                    <ul className="text-primary-text font-medium text-base mt-2">
                      <p className="text-primary-text font-medium text-base">
                        {questions[index].text}
                      </p>
                    </ul>
                  </div>
                </div>
                <div className="flex justify-end gap-4 mt-3 items-center max-w-[calc(100%-80px)] ml-auto">
                  <div className="bg-[#F4F4F4] border border-[#D4D4D4] rounded-[14px] p-4">
                    <p className="text-primary-text font-semibold text-base">
                      {index === 0
                        ? item?.filters?.movePlan
                        : index === 1
                        ? item?.filters?.monthlyRentalBudget
                        : index === 2
                        ? item?.filters?.preferredLocation?.answer
                        : index === 3
                        ? item?.filters?.officeType
                        : index === 4
                        ? item?.filters?.leaseTermsDuration
                        : index === 5
                        ? item?.filters?.officeSpaces
                        : index === 6
                        ? item?.filters?.parking
                        : index === 7
                        ? item?.filters?.parking
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      <div className="text-right my-4"></div>
      {/* )} */}
    </div>
  );
};

const AiHistoryDetailSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenHistory, setIsOpenHistory] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [countData, setCountData] = useState(0);
  const [messages, setMessages] = useState([
    { type: "ai", message: questions[0].text },
  ]);
  const [userInput, setUserInput] = useState("");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [responses, setResponses] = useState({});
  const [waitingForAPI, setWaitingForAPI] = useState(false);
  const [resultCount, setResultCount] = useState(0);
  const [suggestions, setSuggestions] = useState(questions[0].suggestions);
  const [flag, setFlag] = useState(false);
  const { loginInfo } = useAuthStore();
  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleHistory = () => setIsOpenHistory(!isOpenHistory);
  const { propertyInfo, updatePropertyInfo, removePropertyInfo } =
    usePropertyStore();

  const handleSendMessage = async () => {
    if (!userInput.trim() || waitingForAPI) return;

    const currentQuestion = questions[currentQuestionIndex];
    const updatedResponses = { ...responses, [currentQuestion.key]: userInput };
    setResponses(updatedResponses);
    setFlag(false);

    // User's message
    const newMessages = [...messages, { type: "user", message: userInput }];
    setMessages(newMessages);
    setSuggestions(questions[currentQuestionIndex + 1]?.suggestions);

    setUserInput("");

    updatePropertyInfo({
      ...propertyInfo,
      [currentQuestion.key]: { answer: userInput },
    });

    // If the current question is "location", wait for API response first
    if (currentQuestion.key === "location") {
      setWaitingForAPI(true);
      const location = userInput; // Directly use the user input for location
      try {
        setToken(loginInfo ? loginInfo?.token : null);
        // const response = await filterPropertyAPI({ location });

        // if (response?.data?.statusCode === 200) {
        //   setResultCount(response?.data?.count);
        // } else {
        //   console.warn("API Error: 401 or other issue");
        // }
      } catch (error) {
        console.warn("API Error:", error);
      } finally {
        setWaitingForAPI(false);
      }
    }

    // Now proceed with AI response and next question
    const aiResponse = {
      type: "ai",
      suggestions: [`${currentQuestion.label}: ${userInput}`],
    };
    newMessages.push(aiResponse);

    if (currentQuestionIndex < questions.length - 1) {
      const nextQuestion = questions[currentQuestionIndex + 1];
      newMessages.push({
        type: "ai",
        message: nextQuestion.text,
        label: nextQuestion?.label,
      });
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      newMessages.push({
        type: "ai",
        message: "Thanks! Here's what I gathered about your preferences:",
        suggestions: Object.entries(updatedResponses).map(([key, value]) => {
          const label = questions.find((q) => q.key === key)?.label || key;
          return `${label}: ${value}`;
        }),
      });
    }
    setMessages(newMessages);
  };

  const navigate = useNavigate();
  const newChat = () => {
    removePropertyInfo();
    navigate("/");
  };

  const clickOnSuggestion = (suggestion) => {
    setUserInput(suggestion);
    setFlag(true);
  };
  useEffect(() => {
    if (flag) {
      handleSendMessage();
    }
  }, [flag]);

  return (
    <div className="mt-3">
      <div className="mx-auto container lg:mt-8 mt-4">
        <div className="w-full"></div>
        <div className="md:text-right flex items-center justify-end gap-3">
          <button
            onClick={toggleHistory}
            className="bg-red-600 text-white py-2 px-4 rounded-[58px] font-semibold"
          >
            View History
          </button>
          <button
            onClick={newChat}
            className="bg-red-600 text-white  py-2 px-4 min-w-[130px] rounded-[58px] font-semibold"
          >
            New Chat
          </button>
        </div>

        <h1 className="gradient-text text-4xl font-bold mt-3">
          Hi {loginInfo?.user?.fullname}, I am your AI assistance!
        </h1>

        <h4 className="text-lg text-[#5D5D5D] font-semibold mt-2">
          Let's understand your search requirement.
        </h4>

        <div className="xl:min-h-[35vh] 2xl:min-h-[0vh]">
          {messages.map((msg, index) =>
            msg.type === "user" ? (
              <UserMessage key={index} message={msg.message} />
            ) : (
              <AiHistoryDetail
                key={index}
                message={msg.message}
                setHistoryData={setHistoryData}
                setCountData={setCountData}
                suggestions={msg.suggestions}
                allMessages={messages}
                currentQuestionIndex={currentQuestionIndex}
              />
            )
          )}
        </div>

        <ul className="text-primary-text font-medium text-base mt-2">
          {historyData?.length > 0 && (
            <>
              <li>
                ✅ Location:{" "}
                {historyData[0]?.filters?.propertyLocation?.address}
              </li>
              <li>
                ✅ Space: {historyData[0]?.filters?.officeCalculatedSize[0]}m² -{" "}
                {historyData[0]?.filters?.officeCalculatedSize[1]}m² added.
              </li>
              <li>✅ Plan to move: {historyData[0]?.filters?.movePlan}</li>
            </>
          )}

          {historyData?.length >= 1 &&
            historyData[1]?.filters?.monthlyRentalBudget && (
              <li>
                ✅ Budget pricing:{" "}
                {historyData[1]?.filters?.monthlyRentalBudget}
              </li>
            )}

          {historyData?.length >= 2 &&
            historyData[2]?.filters?.preferredLocation && (
              <li>
                ✅ Preferred location:{" "}
                {historyData[2]?.filters?.preferredLocation?.answer}
              </li>
            )}

          {historyData?.length >= 3 && historyData[3]?.filters?.officeType && (
            <li>✅ Office type: {historyData[3]?.filters?.officeType}</li>
          )}

          {historyData?.length >= 4 &&
            historyData[4]?.filters?.leaseTermsDuration && (
              <li>
                ✅ Lease duration: {historyData[4]?.filters?.leaseTermsDuration}
              </li>
            )}

          {historyData?.length >= 5 &&
            historyData[5]?.filters?.officeSpaces && (
              <li>✅ Office spaces: {historyData[5]?.filters?.officeSpaces}</li>
            )}

          {historyData?.length >= 6 && historyData[6]?.filters?.amenities && (
            <li>✅ Amenities: {historyData[6]?.filters?.amenities}</li>
          )}

          {historyData?.length >= 7 && historyData[7]?.filters?.parking && (
            <li>✅ Parking: {historyData[7]?.filters?.parking}</li>
          )}
        </ul>

        {true && (
          <div className="text-center mt-3 mb-8">
            {/* <Link to={`/office-space?index=${historyData?.length}`}> */}
            <button className="text-red-600 font-medium border border-red-600 py-2 px-8 rounded-[58px]">
              {false ? (
                <div className="flex">
                  {/* <ClipLoader size={20} color="red" /> */}
                </div>
              ) : (
                `See ${countData} results`
              )}
            </button>
            {/* </Link> */}
          </div>
        )}
      </div>

      <Drawer open={isOpen} onClose={toggleMenu} direction="left">
        {propertyInfo ? (
          <SummarySection currentQuestionIndex={currentQuestionIndex} />
        ) : (
          ""
        )}
      </Drawer>

      <Drawer open={isOpenHistory} onClose={toggleHistory} direction="left">
        <HistorySection />
      </Drawer>
    </div>
  );
};

export default AiHistoryDetailSection;
